<ion-content [scrollY]="false">
  @if (state.activeActivityId) {
    @if (state.isLoading) {
      <dojo-loader class="flex h-full items-center justify-center" />
    } @else {
      <dojo-examdojo-question
        [isTransitioningBetweenQuestions]="state.isTransitioningBetweenQuestions"
        [footerTemplateRef]="footerTemplate"
        [showExitButton]="!state.areAllQuestionsCompleted"
        (completed)="handleCompletedQuestion($event)"
      />
    }
  }
</ion-content>

<ng-template #footerTemplate>
  @if (isDesktop || !isCanvasVisible()) {
    @if (state.isSmall) {
      <dojo-question-footer-mobile
        [isReadyToGrade]="questionComponent()?.isReadyToGrade() ?? false"
        [overrideNextLabel]="state.areAllQuestionsCompleted ? 'finish' : undefined"
        (selfGrade)="questionComponent()?.selfGradeQuestionAttempt()"
        (mcqGrading)="questionComponent()?.multipleChoiceQuestionGrading()"
        (submitForGrading)="questionComponent()?.submitForGrading()"
        (nextQuestion)="questionComponent()?.goToNextQuestion()"
      />
    } @else {
      <dojo-question-footer-desktop
        [isReadyToGrade]="questionComponent()?.isReadyToGrade() ?? false"
        [overrideNextLabel]="state.areAllQuestionsCompleted ? 'finish' : undefined"
        [showExitButton]="!state.areAllQuestionsCompleted"
        [exitButtonLabel]="'exit'"
        (endPractice)="handleCompletedQuestion('stop')"
        (selfGrade)="questionComponent()?.selfGradeQuestionAttempt()"
        (mcqGrading)="questionComponent()?.multipleChoiceQuestionGrading()"
        (submitForGrading)="questionComponent()?.submitForGrading()"
        (nextQuestion)="questionComponent()?.goToNextQuestion()"
      />
    }
  }
</ng-template>
